import React from "react";
import { useStore } from "../../../../store/store";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function PagingBar() {
  const {
    pagingInfoRef,
    responsePagingInfo,
    goPreviousPage,
    goNextPage,
    goToPage,
    pageButtons,
  } = useStore((state) => state);

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  return (
    <>
      <nav aria-label="Page navigation example" style={{ marginRight: "20px" }}>
        <ul className="pagination justify-content-end">
          <li
            className={`page-item ${previousPageState}`}
            onClick={(event) => goPreviousPage()}
          >
            <a
              className="page-link"
              href="#"
              tabIndex="-1"
              aria-disabled={"true"}
            >
              <FaArrowLeft />
            </a>
          </li>

          {pageButtons.map((item) => {
            let page = pagingInfoRef.pageNumber();
            let disabled =
              page === item.pageNumber ? "disabled disable-paging-btn" : "";
            return (
              <li
                className={`page-item ${disabled}`}
                onClick={(event) => {
                  console.log("---");
                  goToPage(item.pageNumber);
                }}
              >
                <a className="page-link" href="#">
                  {item.name}
                </a>
              </li>
            );
          })}
          <li
            className={`page-item ${nextPageState}`}
            onClick={(event) => goNextPage()}
          >
            <a className="page-link" href="#">
              <FaArrowRight />
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default PagingBar;
